import { Box, FormControlLabel, Modal, Tooltip } from '@material-ui/core'
import React, { useCallback, useEffect, useState } from 'react'
import { CustomCheckbox } from '../../constants/customComponent/CustomCheckbox'
import termsAndConditionsService from '../../services/termsAndConditions.service'
import usersService from '../../services/users.service'

import PropTypes from 'prop-types';
const ModalTerms = ({an8}) => {
    const [urlFile, setUrlFile] = useState({})
    const [available, setAvailable] = useState(false)
    const [isOpen, setIsOpenModal] = useState(false)
    const [isLoading, setIsLoadingData] = useState(false)
        const alreadyAccepted = useCallback(async()=> {            
            const version = localStorage.getItem("pdfName").split(".")[0]
                const versionRegex = version.match(/v\d+$/)?.[0];
                const vr = await usersService.getUserTermsandConditionVersion(an8)
                return versionRegex === vr
        },[an8]) 
       useEffect(() => {
            const isAlreadyAcceepted = async() =>{
                const accepted = await alreadyAccepted()
                if(accepted){
                    setIsOpenModal(false)
                    return
                }
                setIsOpenModal(true)
                // setIsLoadingData(true)
               termsAndConditionsService.getPrivacyAdvertice().then(async(response)=>{
                   const byteString = window.atob(response.data.split(',')[1]);
                   const mimeString = response.data.split(',')[0].split(':')[1].split(';')[0];
    
                         const ab = new ArrayBuffer(byteString.length);
                         const ia = new Uint8Array(ab);
                         for (let i = 0; i < byteString.length; i++) {
                           ia[i] = byteString.charCodeAt(i)
                         }
               
                         const dataBlob = new Blob([ab], { type: mimeString });
               
                         if (window?.navigator?.msSaveOrOpenBlob) {
                           window.navigator.msSaveOrOpenBlob(dataBlob, `${response.name}`);
                           return
                         }
                   
                         const url = window.URL.createObjectURL(dataBlob);
                         const fileName = response.name.split(".")[0]
                        //  await alreadyAccepted("2")
                         setUrlFile({url, name:fileName})
                         setIsLoadingData(false)
                        
                       }).catch((error)=>{
                        console.log(error)
                        setIsOpenModal(false)
                   
             })
            }
            isAlreadyAcceepted()
       },[alreadyAccepted]);
       const onChange = async()=>{
        try{
            setIsLoadingData(true)
            const fileName = urlFile.name.split(".")[0]
            const version = fileName.match(/v\d+$/)?.[0];
            console.log("versiooon")
             await usersService.getTermsandConditionVersion(an8,version)
            setIsLoadingData(false)
             setIsOpenModal(false)
        }catch(error){
            setIsLoadingData(false)
             setIsOpenModal(false)
        }
        

       }
 return (
    <Modal
        open={isOpen}
        className='large'
    >
                <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          boxShadow: 24,
          overflowY: "auto",   
          overflowX: "hidden", 
          borderRadius: 2,
          p: 4,
          width: "80vw",      
          maxHeight:"500px",
          maxWidth: "650px", 
          border:"none",
          outline: "none",
        }}
      > 
      
        <div className="d-flex align-items-center justify-content-evenly">
            

            <h4>Aviso de privacidad</h4>
            <div className='vr'></div>
               <img src="/images/logo.jpg" alt="logo" className="w-50" />
              </div>
              <div className='d-flex flex-column justify-content-center mt-2'>
                    <p>Para continuar utilizando los servicios de portal de clientes Cruz Azul, usted necesita aceptar el nuevo Aviso de Privacidad.</p>
                    <div className="mx-auto">
                        {
                            isLoading  ? ( <span className="custom-icon-loading">
                            <i className="fas fa-spinner fa-spin"></i>
                        </span>) : (
                        <Tooltip title={ available ? "": `Leer aviso de privacidad` }placement="bottom" arrow>
                              <FormControlLabel
                                control={
                                            
                                        <CustomCheckbox
                                          disabled={!available}
                                          onChange={onChange}
                                          // checked={checkedCustomers?.includes(c.an8)}
                                          />
                                }
                                label={
                                    <span className="">Aceptar {"  "}
                                     <a href={urlFile.url}  rel='nooper noreferrer' target="_blank" className="alert-link" onClick={()=>setAvailable(true)}>
                                                 Aviso de Privacidad
                                            </a>
                                  </span>
                                 
                                }
                              />
                                </Tooltip>

                        )
                        }
                            </div>
                   {/* <iframe 
                                src="/Comunicado.pdf"
                                width="800"
                                height="800"
                                
                                /> */}
             </div>
          </Box>
      
    </Modal>
  )

}
ModalTerms.propTypes={
    an8: PropTypes.string
}
export default ModalTerms
